import React, { useState, useEffect } from 'react';
import { Col, FormGroup, Input, Label, Row, Button } from 'reactstrap';
import { connect } from 'react-redux';
import './EpikboxPri.css';
import DropdownSelect from '../../../../ProposalGenerator/DropdownSelect';
import { toast } from 'react-toastify';
import AddPRINumber from '../../../../AddPRINumber';
import AvailablePRI from '../../../../AvailablePRI';
import { getAssignedNumbers, editPriChange, priBoxChange } from '../../../../../actions/EpikBoxes';
import {
  changeBulkBoxSession,
  sendBulkActionsToApi,
} from '../../../../../actions/BoxSessionLogging';
const priTypeItems = [{ label: 'PRI', value: 'PRI' }, { label: 'CAS T1', value: 'CAS T1' }];
const clockingItems = [{ label: 'CPE side', value: 'CPE side' }];
const switchItems = [{ label: '5ESS', value: '5ESS' }];
const framingItems = [{ label: 'ESF', value: 'ESF' }];
const encodingItems = [{ label: 'B8ZS', value: 'B8ZS' }];
const dnisItems = [
  { label: '4', value: '4' },
  { label: '7', value: '7' },
  { label: '10', value: '10' },
];
const EpikboxPri = ({
  box,
  onConfirm,
  boxesList,
  assignedNumbers,
  getAssignedNumbers,
  finalSelectedList,
  onAvailableSave,
  priBoxChange,
  editPriChange,
  onImportConfirm,
  importNumberList,
  importFinalList,
  numberToFilter,
  onAssignAvailablePress,
  changeBulkBoxSession,
  sendBulkActionsToApi,
}) => {
  const [selectType, setSelectType] = useState(priTypeItems[0]);
  const [selectClocking, setSelectClocking] = useState(clockingItems[0]);
  const [selectSwitch, setSelectSwitch] = useState(switchItems[0]);
  const [selectFraming, setSelectFraming] = useState(framingItems[0]);
  const [selectEncoding, setSelectEncoding] = useState(encodingItems[0]);
  const [selectDnis, setSelectDnis] = useState(dnisItems[0]);
  const [bChannelValue, setBChannelValue] = useState('1-23');
  const [dChannelValue, setDChannelValue] = useState('24');
  const [modalStatus, setModalStatus] = useState(false);
  const [availableModal, setAvailableModal] = useState(false);
  const [boxDetails, setBoxDetails] = useState(box);

  useEffect(() => {
    if (boxDetails.priType === 'PRI') {
      setSelectType(priTypeItems[0]);
      setBoxDetails((boxDetails.priType = priTypeItems[0].value));
    } else if (boxDetails.priType === 'CAS T1') {
      setSelectType(priTypeItems[1]);
      setBoxDetails((boxDetails.priType = priTypeItems[1].value));
    } else {
      setSelectType(priTypeItems[0]);
      setBoxDetails((boxDetails.priType = priTypeItems[0].value));
    }
    if (boxDetails.dnis === '4') {
      setSelectDnis(dnisItems[0]);
      setBoxDetails((boxDetails.dnis = dnisItems[0].value));
    } else if (boxDetails.dnis === '7') {
      setSelectDnis(dnisItems[1]);
      setBoxDetails((boxDetails.dnis = dnisItems[1].value));
    } else if (boxDetails.dnis === '10') {
      setSelectDnis(dnisItems[2]);
      setBoxDetails((boxDetails.dnis = dnisItems[2].value));
    } else {
      setSelectDnis(dnisItems[0]);
      setBoxDetails((boxDetails.dnis = dnisItems[0].value));
    }
    if (boxDetails.priClocking === '') {
      setBoxDetails((boxDetails.priClocking = clockingItems[0].value));
    }
    if (boxDetails.switchType === '') {
      setBoxDetails((boxDetails.switchType = switchItems[0].value));
    }
    if (boxDetails.framing === '') {
      setBoxDetails((boxDetails.framing = framingItems[0].value));
    }
    if (boxDetails.encoding === '') {
      setBoxDetails((boxDetails.encoding = encodingItems[0].value));
    }
    if (boxDetails.dChannel === '') {
      setBoxDetails((boxDetails.dChannel = '24'));
    }
    if (boxDetails.bChannel === '') {
      setBoxDetails((boxDetails.bChannel = '1-23'));
    }
    setBoxDetails(boxDetails);
    priBoxChange(boxDetails);
  }, []);
  const saveOptions = () => {
    // [BulkAction] - call api
    onConfirm(boxDetails, 'saveBulk');
  };
  const bChangeFunction = e => {
    const min = 1;
    const max = 24;
    const lowerB = e - min;
    const result = `${min}-${lowerB} ${e}-${max}`;
    if (e.length === 0) {
      setBChannelValue('');
    } else if (e === '24') {
      setBChannelValue('1-23');
    } else {
      setBChannelValue(result);
    }
  };

  const onFormFieldChange = ev => {
    const { name, value } = ev.target;
    if (value <= 24) {
      setDChannelValue(value);
      bChangeFunction(value);
    } else {
      toast.error('You cannot enter more than 24');
    }
  };
  return (
    <div className="priContainer">
      <div className="data-container">
        <div className="box-type-container">
          <h6 className="type-header">PRI Type</h6>
          <DropdownSelect
            options={priTypeItems}
            selectedOption={selectType}
            onSelect={value => {
              // [BulkAction] - Change
              changeBulkBoxSession(`PRI type changed from ${selectType} to ${value}`, 'priType');
              setSelectType(value);
              editPriChange('priType', value.value);
            }}
          />
        </div>

        <div className="box-type-container">
          <h6 className="type-header">PRI Clocking</h6>
          <DropdownSelect
            options={clockingItems}
            selectedOption={selectClocking}
            onSelect={value => {
              // [BulkAction] - Change
              changeBulkBoxSession(
                `PRI clocking changed from ${selectClocking} to ${value}`,
                'priClocking',
              );
              setSelectClocking(value);
              editPriChange('priClocking', value.value);
            }}
          />
        </div>

        <div className="box-type-container">
          <h6 className="type-header">Switch Type</h6>
          <DropdownSelect
            options={switchItems}
            selectedOption={selectSwitch}
            onSelect={value => {
              // [BulkAction] - Change
              changeBulkBoxSession(
                `Switch type changed from ${selectSwitch} to ${value}`,
                'switchType',
              );
              setSelectSwitch(value);
              editPriChange('switchType', value.value);
            }}
          />
        </div>
      </div>
      <div className="data-container">
        <div className="box-type-container">
          <h6 className="type-header">Framing</h6>
          <DropdownSelect
            options={framingItems}
            selectedOption={selectFraming}
            onSelect={value => {
              // [BulkAction] - Change
              changeBulkBoxSession(
                `Framing type changed from ${selectFraming} to ${value}`,
                'framingType',
              );
              setSelectFraming(value);
              editPriChange('framing', value.value);
            }}
          />
        </div>

        <div className="box-type-container">
          <h6 className="type-header">Encoding</h6>
          <DropdownSelect
            options={encodingItems}
            selectedOption={selectEncoding}
            onSelect={value => {
              // [BulkAction] - Change
              changeBulkBoxSession(
                `Encoding type changed from ${selectEncoding} to ${value}`,
                'encodingType',
              );
              setSelectEncoding(value);
              editPriChange('encoding', value.value);
            }}
          />
        </div>

        <div className="box-type-container">
          <h6 className="type-header">DNIS</h6>
          <DropdownSelect
            options={dnisItems}
            selectedOption={selectDnis}
            onSelect={value => {
              // [BulkAction] - Change
              changeBulkBoxSession(`DNIS type changed from ${selectDnis} to ${value}`, 'dnisType');
              setSelectDnis(value);
              editPriChange('dnis', value.value);
            }}
          />
        </div>
      </div>
      <div className="bd-container">
        <Row>
          <Col md={6} sm={12}>
            <FormGroup row>
              <Label className="type-header bold black" for="model" sm={8}>
                D Channel:
              </Label>
              <Col sm={12}>
                <Input
                  disabled
                  type="text"
                  name="dChannel"
                  placeholder="Enter D Channel"
                  value={dChannelValue}
                  onChange={onFormFieldChange}
                />
              </Col>
            </FormGroup>
          </Col>

          <Col md={6} sm={12}>
            <FormGroup row>
              <Label className="type-header bold black" for="model" sm={8}>
                B Channel:
              </Label>
              <Col sm={12}>
                <Input disabled type="text" name="bChannel" value={bChannelValue} />
              </Col>
            </FormGroup>
          </Col>
        </Row>
      </div>
      <div className="bd-container under-line">
        <Row className="number-list-row">
          <Col md={3} sm={6}>
            <h6 className="type-header">Number Assignment</h6>
          </Col>
          <Col md={3} sm={6}>
            <p onClick={() => setModalStatus(true)} className="link-header">
              Import Number
            </p>
          </Col>
          <Col md={5} sm={6}>
            <Button
              color="primary"
              onClick={() => {
                onAssignAvailablePress();
                setAvailableModal(true);
              }}
            >
              Assign available numbers
            </Button>
          </Col>
        </Row>
      </div>
      <div className="bd-container height-list">
        {box.priNumbers.length > 0 ? (
          <Row className="number-list-row">
            <Col md={{ size: 12 }} sm={{ size: 6 }}>
              {box.priNumbers.map(item => {
                return <Label style={{ marginRight: '25px' }}>{item.number}</Label>;
              })}
            </Col>
          </Row>
        ) : (
          <div>
            <h6>No Assigned numbers</h6>
          </div>
        )}
      </div>
      <div className="epiFooter bottom-btn">
        <Button color="primary" style={{ marginRight: '15px' }} onClick={saveOptions}>
          Save
        </Button>
      </div>
      <AddPRINumber
        // phone={this.props.phone}
        data={box}
        importNumberList={importFinalList}
        isOpen={modalStatus}
        onCancel={() => setModalStatus(false)}
        onConfirm={() => {
          onImportConfirm();
          setModalStatus(false);
        }}
      />

      <AvailablePRI
        // phone={this.props.phone}
        numberToFilter={numberToFilter}
        finalSelectedList={finalSelectedList}
        data={assignedNumbers}
        isOpen={availableModal}
        onCancel={() => setAvailableModal(false)}
        onConfirm={() => {
          changeBulkBoxSession(`Assign Number changed`, 'assignNumber');
          onAvailableSave();
          setAvailableModal(false);
        }}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  companies: state.AppState.companies,
  editCompanyGroupData: state.UIState.companies.editCompanyGroupData || '',
  boxesList: state.AppState.boxes,
  optionsBoxUpdate: state.UIState.epikBoxes.optionsBoxUpdate.optionsBox,
  boxDetails: state.AppState.boxDetails.box,
  assignedNumbers: state.AppState.obis.assignedNumbers,
});

const mapDispatchToProps = dispatch => ({
  getAssignedNumbers: (token, cid, uid, priStatus) =>
    dispatch(getAssignedNumbers(token, cid, uid, priStatus)),
  editPriChange: (name, value) => dispatch(editPriChange(name, value)),
  priBoxChange: boxData => dispatch(priBoxChange(boxData)),
  changeBulkBoxSession: (description, key) => dispatch(changeBulkBoxSession(description, key)),
  sendBulkActionsToApi: () => dispatch(sendBulkActionsToApi()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EpikboxPri);
